import styled from 'styled-components';
export var ButtonContainer = styled.div.withConfig({
  displayName: "style__ButtonContainer",
  componentId: "sc-1ee0um1-0"
})(["position:relative;width:100%;display:flex;height:100%;"]);
export var CheckboxContainer = styled.div.withConfig({
  displayName: "style__CheckboxContainer",
  componentId: "sc-1ee0um1-1"
})(["order:0;width:10%;margin-left:5px;height:100%;display:flex;align-items:center;"]);
export var SubItemContainer = styled.div.withConfig({
  displayName: "style__SubItemContainer",
  componentId: "sc-1ee0um1-2"
})(["position:relative;width:300px;left:15px;box-shadow:0px 16px 4px rgba(0,0,0,0.4);"]);
export var PaymentButtonContainer = styled.div.withConfig({
  displayName: "style__PaymentButtonContainer",
  componentId: "sc-1ee0um1-3"
})(["position:relative;height:80%;width:60%;text-align:center;margin:auto;"]);
export var PaymentButton = styled.button.withConfig({
  displayName: "style__PaymentButton",
  componentId: "sc-1ee0um1-4"
})(["width:221px;height:45px;left:866px;top:703px;background:#30c2ff;border:1px solid #30c2ff;box-sizing:border-box;box-shadow:0px 4px 4px rgba(0,0,0,0.25);font-weight:bold;line-height:normal;font-size:18px;color:#ffffff;&:focus{outline:0;border:1px solid white;box-sizing:border-box;box-shadow:0px 4px 4px rgba(0,0,0,0.25);}", ":hover &{background:#30c2ff;box-shadow:0px 4px 4px rgba(0,0,0,0.025);}"], PaymentButtonContainer);
export var FooterContainer = styled.div.withConfig({
  displayName: "style__FooterContainer",
  componentId: "sc-1ee0um1-5"
})(["position:absolute;width:100%;height:20%;bottom:0;"]);